module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.2469ccfe446daa49d5c1.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/glyphicons-halflings-regular.eot
// module id = 686
// module chunks = 2